const SPACE_BETWEEN_LABEL_AND_VALUE = 48;
const TITLE_MARGIN = 10;

export { SPACE_BETWEEN_LABEL_AND_VALUE, TITLE_MARGIN };
